module.exports = __webpack_public_path__ + "img/honer4.cbf2cf10.jpg";